import { render, staticRenderFns } from "./maintenanceRecord.vue?vue&type=template&id=4971ecb4&scoped=true"
import script from "./maintenanceRecord.vue?vue&type=script&lang=js"
export * from "./maintenanceRecord.vue?vue&type=script&lang=js"
import style0 from "./maintenanceRecord.vue?vue&type=style&index=0&id=4971ecb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4971ecb4",
  null
  
)

export default component.exports